<template>
  <div
    class="main-content">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div v-if="send_store" class="card-body">
            <form action="" @submit="requestCalculation">
              <div class="flex">
                <div>
                  <label>Склад отправитель</label>
                  <select v-model="send_store" name="send_store" class="form-control">
                    <option
                      v-for="(store, index) in send_store_list" :key="index"
                      :value="store.id">{{ store.name }}
                    </option>
                  </select>
                </div>
                <div>
                  <label>Склад получатель</label>
                  <select v-model="receive_store" name="receive_store" class="form-control">
                    <option
                      v-for="(store, index) in receive_store_list" :key="index"
                      :value="store.id">{{ store.name }}
                    </option>
                  </select>
                </div>
                <div style="position: relative;min-width: 200px;">
                  <button style="position: absolute;bottom: 0" class="btn btn-info" type="submit">Создать автосписок
                  </button>
                  <label for="check_1">
                    <input type="checkbox" class="from-control" v-model="default_formula" name="" id="check_1">
                    Использовать 60/17
                  </label>
                  <div class="clearfix"/>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div>
      <pulse-loader :loading="loading" :color="color" style="text-align: center"/>
    </div>

    <div v-if="request" class="row">

      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <table class="table table-hover">
              <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Закрываем бронь</th>
              <th class="wd-100">Закрываем Запас</th>
              </thead>
              <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(request.prep_names, request.total_figures)">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ request.total_figures[prep.id].request }}</td>
                <td>{{ request.total_figures[prep.id].store }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h5>Брони</h5>
            <table class="table table-hover">
              <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Для закрытия брони</th>
              <th class="wd-100">На отправителе</th>
              </thead>
              <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(request.prep_names, request.requested_preps)">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ request.requested_preps[prep.id] }}</td>
                <td>{{ request.preps_in_send_store[prep.id] }}</td>
              </tr>
              </tbody>
            </table>
            <h5>Закрываем бронь</h5>
            <table class="table table-hover">
              <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Количество</th>
              </thead>
              <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(request.prep_names ,request.closing_request.close)">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ request.closing_request.close[prep.id] }}</td>
              </tr>
              </tbody>
            </table>
            <h5>НЕ закрываем бронь</h5>
            <table class="table table-hover">
              <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Количество</th>
              </thead>
              <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(request.prep_names ,request.closing_request.no)">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ request.closing_request.no[prep.id] }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h5>Запас</h5>
            <table class="table table-hover">
              <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <!--            <th class="wd-100">Бронь</th>-->
              <th class="wd-100">Запрос на запас</th>
              <th class="wd-100">На получателе</th>
              <th class="wd-100">На Отправителе</th>
              </thead>
              <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(request.prep_names, request.requested_store_preps)">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ request.requested_store_preps[prep.id] }}</td>
                <td>{{ request.preps_in_receive_store[prep.id] }}</td>
                <td>{{ request.store_preps_for_supply[prep.id] }}</td>
              </tr>
              </tbody>
            </table>
            <h5>Закрываем запас</h5>
            <table class="table table-hover">
              <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Количество</th>
              </thead>
              <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(request.prep_names ,request.store_closing_request.close)">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ request.store_closing_request.close[prep.id] }}</td>
              </tr>
              </tbody>
            </table>
            <h5>НЕ закрываем запас</h5>
            <table class="table table-hover">
              <thead>
              <th class="wd-40"/>
              <th class="wd-200"/>
              <th>Препарат</th>
              <th class="wd-100">Количество</th>
              </thead>
              <tbody>
              <tr v-for="(prep, index) in orderedPrepNames(request.prep_names ,request.store_closing_request.no)">
                <td>{{ index+1 }}</td>
                <td>{{ prep.id }}</td>
                <td>{{ prep.name }}</td>
                <td>{{ request.store_closing_request.no[prep.id] }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .clearfix {
    clear: both;
  }

  .flex {
    display: flex;
    /*justify-content: space-around;*/
  }

  .flex div {
    margin-left: 20px;
  }

  .wd-40 {
    width: 40px;
  }

  .wd-100 {
    white-space: normal;
    width: 110px;
  }

  .wd-200 {
    width: 115px;
  }

  table td {
    padding: 2px;
  }
</style>

<script>

  import api from '@/api'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

  export default {

    components: {
      PulseLoader
    },
    data () {
      return {
        color: '#5BBFDE',
        loading: null,
        request: null,
        send_store: null,
        receive_store: null,
        send_store_list: null,
        receive_store_list_data: null,
        default_formula: false
      }
    },
    computed: {
      receive_store_list () {
        if (this.receive_store_list_data) {
          this.receive_store = this.receive_store_list_data[this.send_store][0].id
          return this.receive_store_list_data[this.send_store]
        }
      }
    },

    mounted () {
      this.getStores()
    },
    methods: {
      orderedPrepNames: function (preps, request = false) {
        let sorted = _.orderBy(preps, 'name')
        if (request) {
          sorted = sorted.filter(x => request[x.id])
        }
        return sorted
      },
      async getStores () {
        const { data } = await api.index('/getStores')
        this.send_store_list = data.stores.send
        this.send_store = this.send_store_list[Object.keys(this.send_store_list)[0]].id
        this.receive_store_list_data = data.stores.receive
      },
      requestCalculation: async function (e) {
        this.loading = true
        this.request = null
        e.preventDefault()
        try {
          const { data } = await api.store('/createAutolistOld', {
            send_store: this.send_store,
            receive_store: this.receive_store,
            default_formula: this.default_formula
          })

          this.request = {
            prep_names: data.prep_names,
            requested_preps: data.requested_preps,
            preps_in_send_store: data.preps_in_send_store,
            closing_request: data.closing_request,
            requested_store_preps: data.requested_store_preps,
            preps_in_receive_store: data.preps_in_receive_store,
            store_preps_for_supply: data.store_preps_for_supply,
            store_closing_request: data.store_closing_request,
            total_figures: data.total_figures,
            // store: data.store,
            // store_names: data.store_names,
            // prep_names: data.prep_names,
            // dother_stores: data.dother_stores,
            // store_id: data.store_id,
            // in_send_store: data.in_send_store,
            // in_receive_store: data.in_receive_store,
            // requested_preps: data.requested_preps,
            // sender_prep_names: data.sender_prep_names,
            // sender_order: data.sender_order
          }
          this.loading = false
        } catch (e) {
          console.log(e)
        }
      }
    }
  }

</script>
